import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Users, User, Calendar, Menu } from 'lucide-react';

interface MobileBottomNavProps {
  onMenuClick: () => void;
}

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ onMenuClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 md:hidden">
      <div className="grid grid-cols-5 h-16">
        <button
          onClick={() => handleNavigation('/')}
          className={`flex flex-col items-center justify-center ${
            isActive('/') ? 'text-[#002855]' : 'text-gray-500'
          }`}
        >
          <Home size={24} />
          <span className="text-xs mt-1">Home</span>
        </button>
        
        <button
          onClick={() => handleNavigation('/players')}
          className={`flex flex-col items-center justify-center ${
            isActive('/players') ? 'text-[#002855]' : 'text-gray-500'
          }`}
        >
          <Users size={24} />
          <span className="text-xs mt-1">Players</span>
        </button>
        
        <button
          onClick={() => handleNavigation('/sessions')}
          className={`flex flex-col items-center justify-center ${
            isActive('/sessions') ? 'text-[#002855]' : 'text-gray-500'
          }`}
        >
          <Calendar size={24} />
          <span className="text-xs mt-1">Sessions</span>
        </button>
        
        <button
          onClick={() => handleNavigation('/coaches')}
          className={`flex flex-col items-center justify-center ${
            isActive('/coaches') ? 'text-[#002855]' : 'text-gray-500'
          }`}
        >
          <User size={24} />
          <span className="text-xs mt-1">Coaches</span>
        </button>
        
        <button 
          onClick={onMenuClick}
          className="flex flex-col items-center justify-center text-gray-500"
        >
          <Menu size={24} />
          <span className="text-xs mt-1">More</span>
        </button>
      </div>
    </div>
  );
};

export default MobileBottomNav;